module.exports = __webpack_public_path__ + "static/designPatternsMenuExample-c3ca1dc0cce27bf71089544a64ff0b59.png";